import { Auth0Provider as Auth0ProviderBase } from "@auth0/auth0-react";
import { config } from "@/lib/config";

interface Auth0ProviderProps {
    children: React.ReactNode;
}

/**
 * Auth0 Provider wrapper configured for HelmGuard
 * Handles the initial OAuth flow with Auth0 before token exchange with platform
 */
export function Auth0Provider({ children }: Auth0ProviderProps) {
    const redirectUri = `${window.location.origin}/auth/callback`;

    return (
        <Auth0ProviderBase
            domain={config.auth0Domain}
            clientId={config.auth0ClientId}
            authorizationParams={{
                redirect_uri: redirectUri,
                ...(config.auth0Audience && { audience: config.auth0Audience }),
            }}
            cacheLocation="localstorage"
        >
            {children}
        </Auth0ProviderBase>
    );
}
